module.exports = __webpack_public_path__ + "static/media/girls-small.21163129.mp4";